module.exports = __webpack_public_path__ + "static/media/lizinde_kagarama7.1c54b5ac.jpeg";